import { Link, useSearch, type LinkProps } from "@tanstack/react-location"
import type { ReactNode } from "react"

export type FiestaLinkProps = {
  href?: string
  onClick?: () => void
  resetSearchParams?: boolean
  children?: ReactNode
  className?: string
  to?: LinkProps["to"]
  search?: LinkProps["search"]
  getActiveProps?: LinkProps["getActiveProps"]
  title?: string
  target?: "_blank"
  ariaLabel?: string
  replace?: boolean
}

export const FiestaLink = (props: FiestaLinkProps): JSX.Element => {
  if (props.href) return <ExternalLink {...props} />
  if (props.search || props.to) return <InternalLink {...props} />
  if (props.onClick) return <Button {...props} />
  return <ExternalLink {...props} />
}

const ExternalLink = ({
  ariaLabel,
  children,
  className,
  href,
  title,
  onClick,
  target,
}: FiestaLinkProps) => (
  <a
    className={className}
    href={href}
    title={title}
    onClick={onClick}
    target={target}
    rel="noreferrer"
    aria-label={ariaLabel}
  >
    {children}
  </a>
)

const Button = ({
  ariaLabel,
  className,
  children,
  title,
  onClick,
}: FiestaLinkProps) => (
  <button
    className={className}
    title={title}
    aria-label={ariaLabel}
    onClick={onClick}
  >
    {children}
  </button>
)

const InternalLink = ({
  ariaLabel,
  className,
  resetSearchParams,
  search,
  title,
  children,
  onClick,
  to,
  getActiveProps,
  target,
  replace,
}: FiestaLinkProps) => {
  const searchParams = useSearch()
  if (!search && !resetSearchParams) search = searchParams

  return (
    <Link
      className={className}
      search={search}
      title={title}
      onClick={onClick}
      to={to}
      replace={replace}
      getActiveProps={getActiveProps}
      target={target}
      aria-label={ariaLabel}
    >
      {children}
    </Link>
  )
}
